enum EffectStyle {
	CLOUD = "C"
}

export default EffectStyle;